// extracted by mini-css-extract-plugin
export default {"main":"TextBlock_main__6nMMy","contentWrapper":"TextBlock_contentWrapper__bB+22","title":"TextBlock_title__JZe4i","text":"TextBlock_text__eXELm"};